import {createContext, type PropsWithChildren, use, useMemo, useState} from 'react'
import {useSearchParams} from '@github-ui/use-navigate'

interface CategoryContextType {
  category: string | null
  setCategory: (category: string | null) => void
}

const CategoryContext = createContext<CategoryContextType | undefined>(undefined)

export function useCategory() {
  const context = use(CategoryContext)
  if (!context) throw new Error('useCategory must be used within a CategoryProvider')
  return context
}

export function CategoryProvider({children}: PropsWithChildren) {
  const [searchParams] = useSearchParams()

  const [category, setCategory] = useState<string | null>(() =>
    searchParams.has('type') ? searchParams.get('category') : null,
  )
  const value = useMemo(() => ({category, setCategory}), [category, setCategory])

  return <CategoryContext value={value}>{children}</CategoryContext>
}
